import { Shield, X } from "lucide-react";

export default function CircleOfCalmOverlay({ alert, onClose }) {
  if (!alert) return null;
  return (
    <div
      data-testid="circle-of-calm-overlay"
      className="fixed inset-0 z-[60] flex items-center justify-center bg-[#FBF9F6]/85 backdrop-blur-xl px-6"
    >
      <div className="relative max-w-xl w-full rounded-3xl border hairline bg-white shadow-[0_20px_60px_rgb(44,43,41,0.08)] p-10 sm:p-14 fade-up">
        <button
          type="button"
          onClick={onClose}
          data-testid="circle-of-calm-close"
          aria-label="Close"
          className="absolute top-5 right-5 text-[#6A6863] hover:text-[#2C2B29] transition-colors p-2"
        >
          <X size={18} strokeWidth={1.5} />
        </button>
        <div className="flex items-center gap-3">
          <span className="h-2 w-2 rounded-full bg-[#9BA995] ambient-dot relative" />
          <span className="eyebrow">A circle of calm</span>
        </div>
        <p
          data-testid="circle-of-calm-message"
          className="mt-8 font-serif italic text-3xl sm:text-4xl leading-[1.15] text-[#2C2B29]"
        >
          {alert.message}
        </p>
        <div className="mt-10 flex items-center gap-3 text-xs text-[#6A6863] tracking-wide">
          <Shield size={12} strokeWidth={1.5} className="text-[#8A9984]" />
          From {alert.triggered_by_name} ·{" "}
          {new Date(alert.at).toLocaleTimeString([], {
            hour: "numeric",
            minute: "2-digit",
          })}
        </div>
      </div>
    </div>
  );
}
